/**
 * זיכרון במכשיר לאנימציית הפתיחה (אתחול + קבלת משימה): מה כבר הוצג כאן, כדי שלא
 * לחזור עליו בכל כניסה לאפליקציה או מעבר בין מסכים — רק פתיחה חדשה מנגנת אותו שוב.
 */
const KEY_BOOTED = 'pmr_intro_booted';
const KEY_OPENING = 'pmr_intro_opening';

export interface IntroSeen {
  /** האתחול הכללי כבר הוצג במכשיר הזה */
  booted: boolean;
  /** מזהה הפתיחה האחרונה שהאנימציה שלה הושלמה */
  openingId: string | null;
}

export function readIntroSeen(): IntroSeen {
  try {
    return {
      booted: localStorage.getItem(KEY_BOOTED) === '1',
      openingId: localStorage.getItem(KEY_OPENING),
    };
  } catch {
    return { booted: false, openingId: null };
  }
}

export function markBooted(): void {
  try {
    localStorage.setItem(KEY_BOOTED, '1');
  } catch {
    /* מצב פרטי / אחסון חסום — פשוט נציג את האנימציה שוב */
  }
}

export function markOpeningSeen(openingId: string): void {
  try {
    localStorage.setItem(KEY_BOOTED, '1');
    localStorage.setItem(KEY_OPENING, openingId);
  } catch {
    /* ראו markBooted */
  }
}
